
import ListComponent from "../../../components/mall_orders/Index.vue";

export default {
  components: {
    ListComponent,
  },
};
